import { render, staticRenderFns } from "./RegistroUnico.vue?vue&type=template&id=1fa7b4ce&scoped=true&"
import script from "./RegistroUnico.vue?vue&type=script&lang=js&"
export * from "./RegistroUnico.vue?vue&type=script&lang=js&"
import style0 from "./RegistroUnico.vue?vue&type=style&index=0&id=1fa7b4ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7b4ce",
  null
  
)

export default component.exports